import { render, staticRenderFns } from "./trainingModulePageInformationText2.vue?vue&type=template&id=28f4929c&scoped=true&"
import script from "./trainingModulePageInformationText2.vue?vue&type=script&lang=js&"
export * from "./trainingModulePageInformationText2.vue?vue&type=script&lang=js&"
import style0 from "./trainingModulePageInformationText2.vue?vue&type=style&index=0&id=28f4929c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f4929c",
  null
  
)

export default component.exports